import type { BreakpointValues } from "@porsche-design-system/components-react"
import type { GridItemSize } from "src/components"

export const imageGridSize: BreakpointValues<GridItemSize> = { base: 12, l: 4 }
export const contentGridSize: BreakpointValues<GridItemSize> = { base: 12, l: 8 }
